<button [matMenuTriggerFor]="flags" mat-icon-button class="align-items-center justify-content-center menu-button"
  [class.active]="isMenuOpen" (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()">
  <span class="lang-label">{{ selectedLangLabel() }}</span>
</button>
<mat-menu #flags="matMenu" class="card-with-shadow">
  @for(lang of languages; track lang) {
    <button mat-menu-item (click)="changeLanguage(lang)">
      <div class="d-flex align-items-center">
        <span class="lang-label-small m-r-8">{{ lang.label }}</span>
        <span class="f-s-14">{{ lang.language }}</span>
      </div>
    </button>
  }
</mat-menu>